(function ($) {
    initCalendar();
})(jQuery);